import * as React from 'react';

import Popover from 'components/popover/Popover';

import { __t, applyTranslations } from 'utils/language';

import './tile-standard-content-details-countries.scss';

applyTranslations(require('../../tile-standard-content.i18n.json'));

import type { StatisticsCommon } from 'types';

type Props = {
  items: Array<StatisticsCommon>,
  isCollapsed: boolean
};

const TileStandardContentDetailsCountries = (
  {
    items,
    isCollapsed
  }: Props
): JSX.Element => {
  const renderPopover = () => (
    <Popover
      classNamePopover="tile-standard-content-details-countries__popover"
      triggerComponent={(
        <span className="tile-standard-content-details-countries__more-countries">
          {__t('tile_standard_content.labels.more_countries', { numberOfCountries: items.length - 1 })}
        </span>
      )}
    >
      <div>
        {
          items.slice(1, 3).map(item => (
            <div key={item.label}>
              {`${item.label}: ${item.percentage}%`}
            </div>
          ))
        }
      </div>
    </Popover>
  );

  return (
    <div className="tile-standard-content-details-countries">
      {
        items.slice(0, isCollapsed ? 1 : 3).map(item => (
          <div
            key={`tile-standard-content-details-countries--${item.label}-${item.percentage}`}
            className="tile-standard-content-details-countries__item"
            title={isCollapsed ? undefined : `${item.label}: ${item.percentage}%`}
          >
            <div>
              {item.label}
            </div>
            <div className="tile-standard-content-details-countries__value">
              {item.percentage}%
              {
                isCollapsed && renderPopover()
              }
            </div>
          </div>
        ))
      }
    </div>
  );
};

export default TileStandardContentDetailsCountries;
